import VariationResponse from './variationResponse';

class OrderItem {
  constructor({
    id,
    attributes: {
      unit_price,
      quantity,
      total,
      product_snapshot,
      variation_snapshot,
      description,
      notes,
      createdAt,
      updatedAt,
    },
  }) {
    this.id = id;
    this.unitPrice = unit_price;
    this.qtty = quantity;
    this.total = total;
    this.productSnapshot = product_snapshot;
    this.variation = new VariationResponse(variation_snapshot);
    this.description = description;
    this.notes = notes;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export default OrderItem;
